import React from 'react';
import cn from 'classnames';
import styles from './index.module.scss';

import User from './User';
import RoleSwitch from './RoleSwitch';
import StoreSwitch from './StoreSwitch';
import Notifications from './Notifications';

export default function Nav({ className = '', children = null }) {
  return <div className={cn(styles.container, className)}>{children}</div>;
}

Nav.User = User;
Nav.RoleSwitch = RoleSwitch;
Nav.StoreSwitch = StoreSwitch;
Nav.Notifications = Notifications;
